module.exports = __webpack_public_path__ + "media/landing_page/top_background_inverted-eb17cfe4.png";